<template>
  <div class="summary-list">
    <template v-if="summaryData.length > 2">
      <div v-for="item in summaryData" :key="item.title" class="jj-summary">
        <div class="summary-title">
          <div>
            <img src="@/assets/images/userData/summaryRectangle.png" alt="">
          </div>
          <span>{{ item.title }}</span>
        </div>
        <div class="summary-percent">
          <span>環比</span>
          <span class="percent" :class="growthFn(item.yesterday,item.today)<0?'font-green':'font-purple'">{{
              growthFn(item.yesterday, item.today)
            }}%</span>
        </div>
        <div class="summary-data">
          <div class="data-item">
            <span>今日</span><span class="data">{{ item.today }}</span>
          </div>
          <div class="data-item">
            <span>昨日</span>
            <span class="data">{{ item.yesterday }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="item in summaryData" :key="item.title" class="jj-summary">
        <div class="summary-title">
          <div>
            <img src="@/assets/images/userData/summaryRectangle.png" alt="">
          </div>
          <span>{{ item.title }}</span>
        </div>
        <div class="summary-data summary-percent">
          <div class="data-item">
            <span class="">環比</span>
            <span class="percent" :class="growthFn(item.yesterday,item.today)<0?'font-green':'font-purple'">{{
                growthFn(item.yesterday, item.today)
              }}%</span>
          </div>
          <div class="data-item">
            <span>今日</span><span class="data">{{ item.today }}</span>
          </div>
          <div class="data-item">
            <span>昨日</span>
            <span class="data">{{ item.yesterday }}</span>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: "JjSummary",
  props: {
    summaryData: {
      type: Array,
      default: null
    }
  },
  methods: {
    growthFn(a, b) {
      let result = 0;
      if (a == 0) {
        if (b == 0) {
          result = 0;
        } else {
          result = Number(b) * 100;
        }
      } else {
        result = (Number(b) - Number(a)) / Number(a) * 100;
      }
      return result.toFixed(2)
    },
  }
}
</script>

<style lang="less" scoped>
.summary-list {
  display: flex;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  .jj-summary {
    flex: 1;
    padding: 0.25rem;
    background-color: #FFFFFF;
    border-radius: 0.12rem;
    color: #292929;
    margin-right: 0.25rem;

    .summary-title {
      display: flex;
      align-items: center;

      img {
        flex-shrink: 0;
        width: 0.17rem;
        height: 0.17rem;
        display: inline-block;
        vertical-align: middle;
      }

      span {
        display: inline-block;
        font-size: 0.16rem;
        font-weight: 500;
        margin-left: 0.1rem;
      }
    }

    .summary-percent {
      text-align: left;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;

      span {
        font-size: 0.14rem;
      }

      .percent {
        font-size: 0.3rem;
        margin-left: 0.05rem;
      }

    }

    .summary-data {
      text-align: left;
      position: relative;

      .data-item {
        display: inline-block;
        margin-right: 0.4rem;

        .percent {
          font-size: 0.3rem;
          margin-left: 0.05rem;
        }

        span {
          font-size: 0.14rem;
        }

        .data {
          font-size: 0.22rem;
          margin-left: 0.05rem;
        }
      }

      img {
        position: absolute;
        width: 0.82rem;
        height: 0.04rem;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .jj-summary:last-child {
    margin-right: 0;
  }

  .font-green {
    color: #00D187;
  }

  .font-purple {
    color: #8B57D8;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/JjSummary.vue